import React from "react";
import { Grid } from "@mui/material";
import TextInput from "controls/global/text-input-field/TextInput";

type ProductDetailsProps = {
  submittedDate?: string;
  uwaRequestNumber?: string;
  ownerName?: string;
  uwaRequestStatusTypeName?: string;
};
const ProductStatus = (props: ProductDetailsProps) => {
  return (
    <>

      <Grid item={true} xs={12} sm={6} md={3} lg={3} xl={3}>
        <TextInput
          name={props.submittedDate}
          label="Ordered Date/Time"
          disabled
          value={props.submittedDate}
        />
      </Grid>
      <Grid item={true} xs={12} sm={6} md={3} lg={3} xl={3}>
        <TextInput
          name={props.uwaRequestNumber}
          label="Stewart Request Number"
          disabled
          value={props.uwaRequestNumber}
        />
      </Grid>
      <Grid item={true} xs={12} sm={6} md={4} lg={4} xl={4}>
        <TextInput
          name={props.ownerName}
          label="Owner"
          disabled
          value={props.ownerName}
        />
      </Grid>      
      <Grid item={true} xs={12} sm={6} md={2} lg={2} xl={2}>
        <TextInput
          name={props.uwaRequestStatusTypeName}
          label="Status"
          disabled
          value={props.uwaRequestStatusTypeName}
        />
      </Grid>
    </>
  );
};

export default ProductStatus;
